import React, { Component } from 'react';
import Header from './Header';
import '../scss/_App.scss';
import Services from './Services';
import About from './About';
import Features from './Features';
import Reviews from './Reviews';
import Contact from './Contact';
import Footer from './Footer';

class App extends Component {

  componentDidMount = () => {
    window.addEventListener('scroll', () => {
      let scrolled = window.pageYOffset;
      const background = document.getElementById('background');
      background.style.backgroundPosition = '0 '+ (- (scrolled  * 0.3) + 'px');
    })
  }

  render() {
    return (
      <div className="App">
        <Header />
        <main>
          <About />
          <Services />
          <Features />
          <Reviews />
          <Contact />
        </main>
        <Footer />
      </div>
    );
  }
}

export default App;
